import { fetchWithAuth, BASE_URL } from './client';

export const createSupportTicket = async (ticket) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/support/tickets`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(ticket)
    });

    if (!response.ok) {
        if (response.status === 503) {
            throw new Error("Email service unavailable. Please try again later.");
        }
        if (response.status === 400) {
            throw new Error("Request validation failed. Ensure your email matches your account.");
        }
        throw new Error(`Failed to submit ticket: ${response.status} ${response.statusText}`);
    }

    return response.json();
};
